<section id="collapse-list" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Collapse List</p>

    <div class="m-t-20">
      <div class="row m-t--20">
        <div class="col-12 m-t-20">
          @if (collapseList$ | async; as collapseList) {
            <collapse-list [collapseList]="collapseList"></collapse-list>
          }
        </div>
      </div>
    </div>
  </div>
</section>
